<!-- <div class="video-wrapper">
  <iframe [src]="videoUrl | safe"></iframe>
</div>-->
<div class="image-wrapper">
	<img [src]="videoUrl" alt="" width="100%" height="auto" />
</div>
